<template>
  <div class="mb-6">
    <v-layout class="inv-top-header mb-4">
      <v-flex>
        <h2 class="title">Units Used per Work Area</h2>
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn
        class="mx-0 mb-0"
        text
        small
        :disabled="loading || loadingCSV || items.length === 0  || !no_data.includes(dateError)"
        :loading="loadingCSV"
        @click="exportCSV"
        ><v-icon class="mr-1">cloud_download</v-icon> CSV</v-btn
      >
    </v-layout>

    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        loader-height="2"
        :footer-props="{'items-per-page-options': [10, 20]}"
        class="elevation-1 table-org"
        :header-props="{ 'sort-icon': 'arrow_downward' }"
        mobile-breakpoint="100"
      >
        <template v-slot:item="{item}">
          <tr class="items-body-row">
            <td>
              <span v-if="!no_data.includes(item.note)">{{ item.note }}</span>  
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
                <span v-if="!no_data.includes(item.type) && workAreaTypes.some(i => i.slug === item.type)">{{ workAreaTypes.find(i => i.slug === item.type).name }}</span>  
                <em v-else class="grey--text">No data</em>
              </td>
            <td>
              <v-layout v-if="!no_data.includes(item.commercial_client_id)" style="margin-left: -14px;">
                <v-menu bottom right d-inline-flex>
                  <template v-slot:activator="{ on }">
                    <v-btn class="ma-0" v-on="on" icon>
                      <v-icon color="#999">more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="pa-0">
                    <v-list-item
                      @click="$router.push(`/commercial_client/${item.commercial_client_id}/show`)"
                    >
                      <v-flex class="body-1">
                        <v-icon class="mr-2" color="primary" size="18px">visibility</v-icon>
                        View Client Details
                      </v-flex>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-layout class="wrap align-center">
                  <v-flex v-if="clients.some(i => i.commercial_client_id === item.commercial_client_id)">
                    {{ clients.find(i => i.commercial_client_id === item.commercial_client_id).commercial_customer_name }}
                  </v-flex>
                  <v-flex v-else>
                    <em class="grey--text">No data</em>
                  </v-flex>
                </v-layout>
              </v-layout>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <v-layout v-if="!no_data.includes(item.commercial_location_id)" style="margin-left: -14px;">
                <v-menu bottom right d-inline-flex>
                  <template v-slot:activator="{ on }">
                    <v-btn class="ma-0" v-on="on" icon>
                      <v-icon color="#999">more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="pa-0">
                    <v-list-item
                      @click="$router.push(`/commercial_client/${item.commercial_client_id}/show?commercial_location_id=${item.commercial_location_id}`)"
                    >
                      <v-flex class="body-1">
                        <v-icon class="mr-2" color="primary" size="18px">visibility</v-icon>
                        View Client Details
                      </v-flex>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-layout class="wrap align-center">
                  <v-flex v-if="clients.some(i => i.commercial_location_id === item.commercial_location_id)">
                    {{ clients.find(i => i.commercial_location_id === item.commercial_location_id).commercial_location_name }}
                  </v-flex>
                  <v-flex v-else>
                    <em class="grey--text">No data</em>
                  </v-flex>
                </v-layout>
              </v-layout>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.cross_sell_name)">{{ item.cross_sell_name }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.cross_sell_unit)">{{ item.cross_sell_unit }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.amount)">{{ item.amount }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
          </tr>
        </template>
        <template
          slot="no-data"
          v-if="error_code == 404 || error_code == 500"
        >
          <v-btn color="primary" @click="addResServReport()">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ApiService from "@/common/api.service"
import { mapGetters, mapActions } from "vuex"

export default {
  name: "ResidentialCrossSellsReport",
  props: ['start_date', 'end_date', 'clients', 'dateError'],
  data: () => ({
    no_data: [null, "", undefined, "null"],
    headers: [
      { 
        text: "Work Area Note", 
        value: "note",
        sortable: false,
        align: "left", 
      },
      { 
        text: "Type", 
        value: "type",
        sortable: false,
        align: "left", 
      },
      {
        text: "Commercial Client",
        value: "commercial_client_name",
        sortable: false,
        align: "left", 
      },
      {
        text: "Location",
        value: "commercial_location",
        sortable: false,
        align: "left",
      },
      {
        text: "Cross Sell",
        value: "cross_sell_name",
        sortable: false,
        align: "left",
      },
      {
        text: "Unit",
        value: "cross_sell_unit",
        sortable: false,
        align: "left",
      },
      {
        text: "Amount",
        value: "amount",
        sortable: false,
        align: "left",
      }
    ],
    items: [],
    options: {},
    totalItems: 0,
    draw: 0,
    tableData: {
      draw: 0,
      length: 10,
      page: 0,
      column: 0,
      dir: "asc"
    },
    loading: false,
    loadingCSV: false,
    workAreaTypes: [
      { name: 'Pet Waste Station', slug: 'pet_station' },
      { name: 'Trash Can', slug: 'trash_can' },
      { name: 'Service Area', slug: 'service_area' },
    ],
    error_code: "",
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong..."
  }),
  mounted() {
    if (!this.no_data.includes(this.inventoryPerWorkAreaTableData)) {
      this.options = this.inventoryPerWorkAreaTableData.options
      this.tableData = this.inventoryPerWorkAreaTableData.tableData 
    }
    this.initialize()
  },
  methods: {
    ...mapActions(['setTableData', 'vEmit']),
    initialize(setPage = null) {
      if(this.no_data.includes(this.dateError)) {
        this.loading = true;
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;
  
        this.tableData.column = 0;
        if (
          !this.no_data.includes(sortBy) &&
          !this.no_data.includes(sortBy[0]) &&
          this.headers.some(i => i.value === sortBy[0] && i.sortable !== false)
        ) {
          this.tableData.column = this.headers.find(
            i => i.value === sortBy[0]
          ).sort_column;
        }
        this.tableData.dir = !this.no_data.includes(sortDesc) && sortDesc[0] === true ? "asc" : "desc";
  
        this.tableData.length = itemsPerPage;
  
        this.tableData.page = page;
        this.tableData.search = this.search;
        this.tableData.draw++;
        this.draw = this.tableData.draw;

        let filtersForSaving = {
          tableData: _.cloneDeep(this.tableData),
          options: _.cloneDeep(this.options),
        }
        filtersForSaving.tableData.draw = 0
        this.setTableData({key: 'inventoryPerWorkAreaTableData', value: filtersForSaving})

        this.tableData.start_date = this.start_date
        this.tableData.end_date = this.end_date

        ApiService.get("/inventory_tracking/inventory_log", this.tableData)
          .then(response => {
            this.draw++
            this.items = response.data.log_per_work_area.data
            this.totalItems = response.data.log_per_work_area.total
            if (setPage) { this.options.page = setPage }
            this.loading = false;
          })
          .catch(error => {
            console.log(error)
            this.loading = false
          })
      }
    },
    exportCSV() {
      if(this.no_data.includes(this.dateError)) {
        this.loadingCSV = true

        let body = {
          start_date: this.start_date,
          end_date: this.end_date,
          export: true
        }

        ApiService.get("/inventory_tracking/inventory_log", body)
          .then(response => {
            let items = response.data.log_per_work_area
            let loadedFromDate = body.start_date
            let loadedToDate = body.end_date

            let csvContent = ""
            let headers = '"Work Area Note","Type","Commercial Client","Location","Cross Sell","Unit","Amount"'
            let csvData = []
            items.forEach(item => {
              let row = {
                note: !this.no_data.includes(item.note)
                  ? `"${item.note}"`
                  : `""`,
                type: !this.no_data.includes(item.type) && this.workAreaTypes.some(i => i.slug === item.type)
                  ? `"${this.workAreaTypes.find(i => i.slug === item.type).name}"`
                  : `""`,
                commercial_customer_name: 
                  !this.no_data.includes(item.commercial_client_id) &&
                  this.clients.some(i => i.commercial_client_id === item.commercial_client_id)
                  ? `"${this.clients.find(i => i.commercial_client_id === item.commercial_client_id).commercial_customer_name}"`
                  : `""`,
                commercial_location_id: 
                  !this.no_data.includes(item.commercial_location_id) &&
                  this.clients.some(i => i.commercial_location_id === item.commercial_location_id)
                  ? `"${this.clients.find(i => i.commercial_location_id === item.commercial_location_id).commercial_location_name}"`
                  : `""`,
                cross_sell_name: !this.no_data.includes(item.cross_sell_name)
                  ? `"${item.cross_sell_name}"`
                  : `""`,
                cross_sell_unit: !this.no_data.includes(item.cross_sell_unit)
                  ? `"${item.cross_sell_unit}"`
                  : `""`,
                amount: !this.no_data.includes(item.amount)
                  ? `"${item.amount}"`
                  : `""`,
              }
              csvData.push(row)
            });

            csvContent += [
              headers,
              ...csvData.map(item => Object.values(item).join(","))
            ].join("\n").replace(/(^\[)|(\]$)/gm, "")

            const data = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
            const url = URL.createObjectURL(data)
            const link = document.createElement("a");
            link.setAttribute("href", url);
            let fileName = `Units Used per Work Area - from ${loadedFromDate} to ${loadedToDate}.csv`
            link.setAttribute(
              "download",
              fileName
            );
            link.click();
            this.loadingCSV = false
          })
          .catch(error => {
            this.vEmit({
              name: "notification", 
              data: {
                status: "error",
                text: "Oops something went wrong..."
              }
            });
            this.loadingCSV = false
          });
      }
    }
  },
  computed: {
    ...mapGetters(['inventoryPerWorkAreaTableData']),
    dateFilters() {
      return `${this.start_date}-${this.end_date}`
    }
  },
  watch: {
    options: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.initialize();
        }
      },
      deep: true
    },
    'dateFilters': function (val) {
      this.initialize(1)
    }
  }
};
</script>